var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1566 4.68652H4.59035C4.16857 4.68652 3.76405 4.85408 3.4658 5.15233C3.16755 5.45058 3 5.85509 3 6.27688V17.4093C3 17.8311 3.16755 18.2356 3.4658 18.5339C3.76405 18.8321 4.16857 18.9997 4.59035 18.9997H15.7228C16.1446 18.9997 16.5491 18.8321 16.8474 18.5339C17.1456 18.2356 17.3132 17.8311 17.3132 17.4093V11.8431",
    stroke: "#A175FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1203 3.49406C16.4367 3.17772 16.8657 3 17.3131 3C17.7605 3 18.1895 3.17772 18.5059 3.49406C18.8222 3.8104 18.9999 4.23945 18.9999 4.68682C18.9999 5.1342 18.8222 5.56325 18.5059 5.87959L10.9517 13.4338L7.771 14.2289L8.56617 11.0482L16.1203 3.49406Z",
    stroke: "#A175FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.470e552989567406c5d6b47547fca939.svg";
export { ForwardRef as ReactComponent };